const SliderPreset = {
    // Extend presets
    extend(presets) {
        Object.assign(this, presets);
        return this;
    },

    // Add single preset
    add(name, callback) {
        this[name] = callback;
        return this;
    },

    // Default preset
    default: function (config) {
        if (config.slidesPerView >= 1) {
            config.breakpoints['0'] = {
                slidesPerView: 1,
            };
        }
        if (config.slidesPerView >= 2) {
            config.breakpoints['520'] = {
                slidesPerView: 2,
            };
        }
        if (config.slidesPerView >= 3) {
            config.breakpoints['840'] = {
                slidesPerView: 3,
            };
        }
        if (config.slidesPerView >= 4) {
            config.breakpoints['1350'] = {
                slidesPerView: 4,
            };
        }
        if (config.slidesPerView >= 5) {
            config.breakpoints['1800'] = {
                slidesPerView: 5,
            };
        }
        if (config.slidesPerView >= 6) {
            config.breakpoints['2000'] = {
                slidesPerView: 6,
            };
        }
        return config;
    },

    // Carrousel de partenaires
    partners: function (config) {
        if (config.slidesPerView >= 1) {
            config.breakpoints['0'] = {
                slidesPerView: 1,
            };
        }
        if (config.slidesPerView >= 2) {
            config.breakpoints['360'] = {
                slidesPerView: 2,
            };
        }
        if (config.slidesPerView >= 3) {
            config.breakpoints['540'] = {
                slidesPerView: 3,
            };
        }
        if (config.slidesPerView >= 4) {
            config.breakpoints['720'] = {
                slidesPerView: 4,
            };
        }
        if (config.slidesPerView >= 5) {
            config.breakpoints['900'] = {
                slidesPerView: 5,
            };
        }
        if (config.slidesPerView >= 6) {
            config.breakpoints['1080'] = {
                slidesPerView: 6,
            };
        }
        if (config.slidesPerView >= 7) {
            config.breakpoints['1260'] = {
                slidesPerView: 7,
            };
        }
        if (config.slidesPerView >= 8) {
            config.breakpoints['1440'] = {
                slidesPerView: 8,
            };
        }
        if (config.slidesPerView >= 9) {
            config.breakpoints['1620'] = {
                slidesPerView: 9,
            };
        }
        if (config.slidesPerView >= 10) {
            config.breakpoints['1800'] = {
                slidesPerView: 10,
            };
        }
        if (config.slidesPerView >= 11) {
            config.breakpoints['1880'] = {
                slidesPerView: 11,
            };
        }
        if (config.slidesPerView >= 12) {
            config.breakpoints['1920'] = {
                slidesPerView: 12,
            };
        }
        return config;
    },

    // Miniatures
    thumbs: function (config) {
        if (config.slidesPerView >= 3) {
            config.breakpoints['0'] = {
                slidesPerView: 3,
            };
        }
        if (config.slidesPerView >= 4) {
            config.breakpoints['620'] = {
                slidesPerView: 4,
            };
        }
        if (config.slidesPerView >= 5) {
            config.breakpoints['950'] = {
                slidesPerView: 5,
            };
        }
        if (config.slidesPerView >= 6) {
            config.breakpoints['1080'] = {
                slidesPerView: 6,
            };
        }
        return config;
    },

    // Carrousel de partenaires
    alerts: function (config) {
        return config;
    },
};

if (typeof window !== 'undefined') {
    window.SliderPreset = SliderPreset;
}
if (typeof global !== 'undefined') {
    global.SliderPreset = SliderPreset;
}

export default SliderPreset;
